import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SharedservicesService } from '../../../../services/sharedservices.service';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  mail: any;
  mail1: any;
  password: any;
  mailver: any;
  passver: any;
  email: any;
  forgotemail: any;
  npassword: any;
  select: any;
  getUserDetails: any;
  getUserDetails1 :any;
  location = [];
  latitude: any;
  longitude: any;
  accuracy: any;
  userType = [
  {
    "name":"usercustomer"
  },
  {
    "name":"useragent"
  }];
  apiRoot: string = this.ref.GetPostURL();

  constructor(private router: Router,private ref: SharedservicesService,private http: HttpClient) { 
    var userdata = JSON.parse(localStorage.getItem('customerInfo'));
    if(userdata) {
      this.router.navigate(['/app/dashboard']);
    } else {
      this.router.navigate(['/']);
    }
  }

  ngOnInit() {
  }
  checkm(e) {
    this.email = e;
    var pattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*\.\w{2,3}/;
    if (e.match(pattern)) {
      var mailerr = <HTMLElement>document.getElementById('mailvalid');
      mailerr.style.display = 'block';
      var mailer = <HTMLElement>document.getElementById('mailerr');
      mailer.style.display = 'none';
      var mail = <HTMLElement>document.getElementById('emailHelp');
      mail.style.display = 'none';
      var btn = <HTMLInputElement>document.getElementById('button');
      btn.disabled = false;
    }
    else {
      var mailerr = <HTMLElement>document.getElementById('mailvalid');
      mailerr.style.display = 'none';
      var mailer = <HTMLElement>document.getElementById('mailerr');
      mailer.style.display = 'block';
      var mail = <HTMLElement>document.getElementById('emailHelp');
      mail.style.display = 'none';
    }
  }
  checkpw(e) {
    this.npassword = e;
    var pattern = /^.{6,}$/;
    if (e.match(pattern)) {
      var mailerr = <HTMLElement>document.getElementById('pwvalid');
      mailerr.style.display = 'block';
      var mailer = <HTMLElement>document.getElementById('pwerr');
      mailer.style.display = 'none';
      var btn = <HTMLInputElement>document.getElementById('button');
      btn.disabled = false;
    }
    else {
      var mailerr = <HTMLElement>document.getElementById('pwvalid');
      mailerr.style.display = 'none';
      var mailer = <HTMLElement>document.getElementById('pwerr');
      mailer.style.display = 'block';
    }
  }
  onChange(e) {
    this.select = e.name;
  }
  // onChangeforgot(e) {
  //   this.select = e;
  // }
  checkm1(e){
    this.forgotemail = e;
    var pattern = /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/; 
    if(e.match(pattern)){
       var mailerr = <HTMLElement>document.getElementById('mailvalid1');
       mailerr.style.display = 'block';
       var mailer = <HTMLElement>document.getElementById('mailerr1');
       mailer.style.display = 'none';
       var btn = <HTMLInputElement>document.getElementById('button1');
       btn.disabled = false;
    }
    else{
      var mailerr = <HTMLElement>document.getElementById('mailvalid1');
       mailerr.style.display = 'none';
       var mailer = <HTMLElement>document.getElementById('mailerr1');
       mailer.style.display = 'block';
    }
  }
  login(){
      var msg = <HTMLElement>document.getElementById('msg');
      var mpattern = /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/;
      var ppattern = /^.{6,}$/;
      // var user = String(this.select);
      if (String(this.email).match(mpattern) && (String(this.npassword).match(ppattern)) && (String(this.select) != "undefined")) {
        msg.style.display = 'none';
        var userData = {
          'email' : this.email,
          'password': this.npassword,
          'userType': this.select
        };
        if (this.select === 'usercustomer') {
          this.CheckLoginEmail(userData, 'usercustomer');
        } else if (this.select === 'useragent') {
          this.CheckLoginEmail(userData, 'useragent');
        }
      } else {
        msg.style.display = 'block';
      }
    }
    CheckLoginEmail(userData, status) {
      if (status === 'usercustomer') {
        this.ref.CustomerLogin(userData).subscribe((res) => {
          if (res) {
            const result = JSON.parse(JSON.stringify(res));
            this.getUserDetails = result;
            var CustomerInfo = {
                'email': this.getUserDetails.userData.email,
                'usertype':this.getUserDetails.userData.userType,
                'auth': this.getUserDetails.auth,
                'token': this.getUserDetails.token
            };
            this.ref.storeDatabwComp(CustomerInfo);
            this.router.navigate(['/app/dashboard'], { queryParams: {  } });
          }
        },
          err => {
            (<HTMLInputElement>document.getElementById("EmailPassErr")).innerHTML = err.error;
            var value = (<HTMLInputElement>document.getElementById("EmailPassErr"));
            value.style.display = 'block';
          }
        );
      } else if (status === 'useragent') {
        this.ref.AgentLogin(userData).subscribe((res) => {
          if (res) {
            const result = JSON.parse(JSON.stringify(res));
            this.getUserDetails = result;
            var CustomerInfo = {
                'email': this.getUserDetails.userData.email,
                'usertype':this.getUserDetails.userData.userType,
                'auth': this.getUserDetails.auth,
                'token': this.getUserDetails.token
            };
            this.ref.storeDatabwComp(CustomerInfo);
            this.router.navigate(['/app/dashboard'], { queryParams: {  } });
          }
        },
          err => {
            (<HTMLInputElement>document.getElementById("EmailPassErr")).innerHTML = err.error;
            var value = (<HTMLInputElement>document.getElementById("EmailPassErr"));
            value.style.display = 'block';
          }
        );
      }
      // this.http.post(posturl, userData).subscribe((res) => {
      //   if (res) {
      //     this.getUserDetails = res;
      //     var CustomerInfo = {
      //         'email': this.getUserDetails.userData.email,
      //         'usertype':this.getUserDetails.userData.userType,
      //         'auth': this.getUserDetails.auth,
      //         'token': this.getUserDetails.token
      //     };
      //     this.ref.storeDatabwComp(CustomerInfo);   
      //     this.router.navigate(['/app/dashboard'], { queryParams: {  } });
      //     }
      //   },
      //   err => {
      //     (<HTMLInputElement>document.getElementById("EmailPassErr")).innerHTML = err.error;
      //     var value = (<HTMLInputElement>document.getElementById("EmailPassErr"));
      //     value.style.display = 'block';
      //     }
      // );
    }
}
